var cov_fz7g5lf8l = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/OptionList.tsx",
      hash = "4d21ecd41e9a3bbd75ef7b91fce95523f466b4a8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/OptionList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 51
        }
      },
      "1": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 16
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "3": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 46
        }
      },
      "4": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 50
        }
      },
      "5": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 52
        }
      },
      "6": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 58
        }
      },
      "7": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 48
        }
      },
      "8": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "9": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 57
        }
      },
      "10": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 53
        }
      },
      "11": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 65
        }
      },
      "12": {
        start: {
          line: 46,
          column: 43
        },
        end: {
          line: 46,
          column: 64
        }
      },
      "13": {
        start: {
          line: 50,
          column: 21
        },
        end: {
          line: 50,
          column: 31
        }
      },
      "14": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "15": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 28
        }
      },
      "16": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 60,
          column: 8
        }
      },
      "17": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "18": {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 54
        }
      },
      "19": {
        start: {
          line: 58,
          column: 10
        },
        end: {
          line: 58,
          column: 50
        }
      },
      "20": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 70
        }
      },
      "21": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 38
        }
      },
      "22": {
        start: {
          line: 70,
          column: 45
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "23": {
        start: {
          line: 71,
          column: 39
        },
        end: {
          line: 71,
          column: 49
        }
      },
      "24": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 73,
          column: 27
        }
      },
      "25": {
        start: {
          line: 72,
          column: 34
        },
        end: {
          line: 72,
          column: 59
        }
      },
      "26": {
        start: {
          line: 73,
          column: 9
        },
        end: {
          line: 73,
          column: 27
        }
      },
      "27": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "28": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 20
        }
      },
      "29": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 28
        }
      },
      "30": {
        start: {
          line: 81,
          column: 17
        },
        end: {
          line: 81,
          column: 44
        }
      },
      "31": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "32": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 84,
          column: 26
        }
      },
      "33": {
        start: {
          line: 83,
          column: 20
        },
        end: {
          line: 83,
          column: 35
        }
      },
      "34": {
        start: {
          line: 84,
          column: 11
        },
        end: {
          line: 84,
          column: 26
        }
      },
      "35": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 44
        }
      },
      "36": {
        start: {
          line: 86,
          column: 24
        },
        end: {
          line: 86,
          column: 44
        }
      },
      "37": {
        start: {
          line: 88,
          column: 22
        },
        end: {
          line: 88,
          column: 38
        }
      },
      "38": {
        start: {
          line: 89,
          column: 19
        },
        end: {
          line: 89,
          column: 37
        }
      },
      "39": {
        start: {
          line: 90,
          column: 24
        },
        end: {
          line: 90,
          column: 56
        }
      },
      "40": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "41": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 54
        }
      },
      "42": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 64
        }
      },
      "43": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 47
        }
      },
      "44": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 35
        }
      },
      "45": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 46
        }
      },
      "46": {
        start: {
          line: 100,
          column: 28
        },
        end: {
          line: 100,
          column: 46
        }
      },
      "47": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 82
        }
      },
      "48": {
        start: {
          line: 102,
          column: 11
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "49": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 54
        }
      },
      "50": {
        start: {
          line: 106,
          column: 27
        },
        end: {
          line: 106,
          column: 60
        }
      },
      "51": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 65
        }
      },
      "52": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 48
        }
      },
      "53": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 64
        }
      },
      "54": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "55": {
        start: {
          line: 111,
          column: 28
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "56": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 83
        }
      },
      "57": {
        start: {
          line: 113,
          column: 11
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "58": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 46
        }
      },
      "59": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 50
        }
      },
      "60": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 118,
          column: 54
        }
      },
      "61": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 33
        }
      },
      "62": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 33
        }
      },
      "63": {
        start: {
          line: 133,
          column: 27
        },
        end: {
          line: 133,
          column: 33
        }
      },
      "64": {
        start: {
          line: 134,
          column: 72
        },
        end: {
          line: 134,
          column: 82
        }
      },
      "65": {
        start: {
          line: 135,
          column: 23
        },
        end: {
          line: 135,
          column: 47
        }
      },
      "66": {
        start: {
          line: 136,
          column: 26
        },
        end: {
          line: 136,
          column: 54
        }
      },
      "67": {
        start: {
          line: 137,
          column: 20
        },
        end: {
          line: 137,
          column: 42
        }
      },
      "68": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 59
        }
      },
      "69": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "70": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 52
        }
      },
      "71": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 34
        }
      },
      "72": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 56
        }
      },
      "73": {
        start: {
          line: 145,
          column: 34
        },
        end: {
          line: 145,
          column: 56
        }
      },
      "74": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 80
        }
      },
      "75": {
        start: {
          line: 148,
          column: 46
        },
        end: {
          line: 148,
          column: 80
        }
      },
      "76": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 52
        }
      },
      "77": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 61
        }
      },
      "78": {
        start: {
          line: 153,
          column: 16
        },
        end: {
          line: 153,
          column: 63
        }
      },
      "79": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 76
        }
      },
      "80": {
        start: {
          line: 154,
          column: 43
        },
        end: {
          line: 154,
          column: 76
        }
      },
      "81": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 28
        }
      },
      "82": {
        start: {
          line: 155,
          column: 19
        },
        end: {
          line: 155,
          column: 28
        }
      },
      "83": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 85
        }
      },
      "84": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 53
        }
      },
      "85": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 163,
          column: 5
        }
      },
      "86": {
        start: {
          line: 162,
          column: 6
        },
        end: {
          line: 162,
          column: 25
        }
      },
      "87": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "88": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 42
        }
      },
      "89": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 39
        }
      },
      "90": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 18
        }
      },
      "91": {
        start: {
          line: 193,
          column: 41
        },
        end: {
          line: 193,
          column: 51
        }
      },
      "92": {
        start: {
          line: 194,
          column: 17
        },
        end: {
          line: 194,
          column: 19
        }
      },
      "93": {
        start: {
          line: 195,
          column: 25
        },
        end: {
          line: 195,
          column: 49
        }
      },
      "94": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 198,
          column: 5
        }
      },
      "95": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 18
        }
      },
      "96": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 204,
          column: 7
        }
      },
      "97": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 204,
          column: 7
        }
      },
      "98": {
        start: {
          line: 205,
          column: 4
        },
        end: {
          line: 206,
          column: 116
        }
      },
      "99": {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 206,
          column: 116
        }
      },
      "100": {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 239,
          column: 5
        }
      },
      "101": {
        start: {
          line: 217,
          column: 12
        },
        end: {
          line: 217,
          column: 34
        }
      },
      "102": {
        start: {
          line: 222,
          column: 12
        },
        end: {
          line: 235,
          column: 14
        }
      },
      "103": {
        start: {
          line: 243,
          column: 108
        },
        end: {
          line: 243,
          column: 118
        }
      },
      "104": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 248,
          column: 9
        }
      },
      "105": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 261,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 51
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 38
          }
        },
        loc: {
          start: {
            line: 46,
            column: 43
          },
          end: {
            line: 46,
            column: 64
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 62
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 49
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 55,
            column: 55
          },
          end: {
            line: 55,
            column: 56
          }
        },
        loc: {
          start: {
            line: 55,
            column: 61
          },
          end: {
            line: 60,
            column: 7
          }
        },
        line: 55
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        },
        loc: {
          start: {
            line: 64,
            column: 25
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 64
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 26
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 68
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 164,
            column: 3
          }
        },
        line: 132
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 3
          }
        },
        loc: {
          start: {
            line: 166,
            column: 45
          },
          end: {
            line: 170,
            column: 3
          }
        },
        line: 166
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 172,
            column: 3
          }
        },
        loc: {
          start: {
            line: 172,
            column: 20
          },
          end: {
            line: 174,
            column: 3
          }
        },
        line: 172
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 176,
            column: 2
          },
          end: {
            line: 176,
            column: 3
          }
        },
        loc: {
          start: {
            line: 176,
            column: 15
          },
          end: {
            line: 240,
            column: 3
          }
        },
        line: 176
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 216,
            column: 15
          },
          end: {
            line: 216,
            column: 16
          }
        },
        loc: {
          start: {
            line: 216,
            column: 21
          },
          end: {
            line: 218,
            column: 11
          }
        },
        line: 216
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 221,
            column: 68
          },
          end: {
            line: 221,
            column: 69
          }
        },
        loc: {
          start: {
            line: 222,
            column: 12
          },
          end: {
            line: 235,
            column: 14
          }
        },
        line: 222
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 242,
            column: 3
          }
        },
        loc: {
          start: {
            line: 242,
            column: 11
          },
          end: {
            line: 262,
            column: 3
          }
        },
        line: 242
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 32,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 43
          },
          end: {
            line: 32,
            column: 45
          }
        }, {
          start: {
            line: 32,
            column: 48
          },
          end: {
            line: 32,
            column: 49
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 31
          }
        }, {
          start: {
            line: 52,
            column: 35
          },
          end: {
            line: 52,
            column: 72
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 65,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 65,
            column: 27
          }
        }, {
          start: {
            line: 65,
            column: 31
          },
          end: {
            line: 65,
            column: 51
          }
        }, {
          start: {
            line: 65,
            column: 56
          },
          end: {
            line: 65,
            column: 70
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 73,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 73,
            column: 27
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 73,
            column: 27
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 75
      },
      "7": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 82
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 12
          }
        }, {
          start: {
            line: 82,
            column: 16
          },
          end: {
            line: 82,
            column: 44
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 84,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 84,
            column: 26
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 84,
            column: 26
          }
        }],
        line: 83
      },
      "10": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 44
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 44
          }
        }],
        line: 86
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 100,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 100,
            column: 46
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 100,
            column: 46
          }
        }],
        line: 100
      },
      "13": {
        loc: {
          start: {
            line: 102,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        }],
        line: 102
      },
      "14": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 44
          }
        }, {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 44
          }
        }],
        line: 111
      },
      "15": {
        loc: {
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        }, {
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 119,
            column: 5
          }
        }],
        line: 113
      },
      "16": {
        loc: {
          start: {
            line: 113,
            column: 15
          },
          end: {
            line: 113,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 15
          },
          end: {
            line: 113,
            column: 31
          }
        }, {
          start: {
            line: 113,
            column: 35
          },
          end: {
            line: 113,
            column: 52
          }
        }],
        line: 113
      },
      "17": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 33
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 33
          }
        }],
        line: 133
      },
      "18": {
        loc: {
          start: {
            line: 137,
            column: 20
          },
          end: {
            line: 137,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 37
          },
          end: {
            line: 137,
            column: 38
          }
        }, {
          start: {
            line: 137,
            column: 41
          },
          end: {
            line: 137,
            column: 42
          }
        }],
        line: 137
      },
      "19": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }],
        line: 141
      },
      "20": {
        loc: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 28
          }
        }, {
          start: {
            line: 141,
            column: 32
          },
          end: {
            line: 141,
            column: 44
          }
        }],
        line: 141
      },
      "21": {
        loc: {
          start: {
            line: 145,
            column: 6
          },
          end: {
            line: 145,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 6
          },
          end: {
            line: 145,
            column: 56
          }
        }, {
          start: {
            line: 145,
            column: 6
          },
          end: {
            line: 145,
            column: 56
          }
        }],
        line: 145
      },
      "22": {
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 80
          }
        }, {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 80
          }
        }],
        line: 148
      },
      "23": {
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 76
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 76
          }
        }],
        line: 154
      },
      "24": {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 28
          }
        }, {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 28
          }
        }],
        line: 155
      },
      "25": {
        loc: {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        }, {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        }],
        line: 161
      },
      "26": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 17
          }
        }, {
          start: {
            line: 161,
            column: 21
          },
          end: {
            line: 161,
            column: 34
          }
        }],
        line: 161
      },
      "27": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }],
        line: 167
      },
      "28": {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 9
          },
          end: {
            line: 167,
            column: 39
          }
        }, {
          start: {
            line: 167,
            column: 43
          },
          end: {
            line: 167,
            column: 48
          }
        }, {
          start: {
            line: 167,
            column: 53
          },
          end: {
            line: 167,
            column: 84
          }
        }],
        line: 167
      },
      "29": {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }, {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }],
        line: 196
      },
      "30": {
        loc: {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 204,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 204,
            column: 7
          }
        }, {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 204,
            column: 7
          }
        }],
        line: 199
      },
      "31": {
        loc: {
          start: {
            line: 202,
            column: 11
          },
          end: {
            line: 202,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 202,
            column: 42
          },
          end: {
            line: 202,
            column: 60
          }
        }, {
          start: {
            line: 202,
            column: 63
          },
          end: {
            line: 202,
            column: 70
          }
        }],
        line: 202
      },
      "32": {
        loc: {
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 206,
            column: 116
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 206,
            column: 116
          }
        }, {
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 206,
            column: 116
          }
        }],
        line: 205
      },
      "33": {
        loc: {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 205,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 205,
            column: 25
          }
        }, {
          start: {
            line: 205,
            column: 29
          },
          end: {
            line: 205,
            column: 42
          }
        }],
        line: 205
      },
      "34": {
        loc: {
          start: {
            line: 206,
            column: 73
          },
          end: {
            line: 206,
            column: 108
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 73
          },
          end: {
            line: 206,
            column: 82
          }
        }, {
          start: {
            line: 206,
            column: 86
          },
          end: {
            line: 206,
            column: 108
          }
        }],
        line: 206
      },
      "35": {
        loc: {
          start: {
            line: 210,
            column: 25
          },
          end: {
            line: 210,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 34
          },
          end: {
            line: 210,
            column: 40
          }
        }, {
          start: {
            line: 210,
            column: 43
          },
          end: {
            line: 210,
            column: 52
          }
        }],
        line: 210
      },
      "36": {
        loc: {
          start: {
            line: 226,
            column: 19
          },
          end: {
            line: 226,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 226,
            column: 52
          },
          end: {
            line: 226,
            column: 86
          }
        }, {
          start: {
            line: 226,
            column: 89
          },
          end: {
            line: 226,
            column: 109
          }
        }],
        line: 226
      },
      "37": {
        loc: {
          start: {
            line: 226,
            column: 19
          },
          end: {
            line: 226,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 19
          },
          end: {
            line: 226,
            column: 20
          }
        }, {
          start: {
            line: 226,
            column: 24
          },
          end: {
            line: 226,
            column: 49
          }
        }],
        line: 226
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/OptionList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { getKey } from '../utils/uid';
import { setTranslate } from '../utils/dom/translate';
import List from '../AnimationList';
import Scroll from '../Scroll';
import Spin from '../Spin';
import { getLocale } from '../locale';
import { selectClass } from './styles';
import Option from './Option';
import { getDirectionClass } from '../utils/classname';
import { getCustomList } from './utils';
var ScaleList = (cov_fz7g5lf8l.s[0]++, List(['fade', 'scale-y'], 'fast'));

var OptionList =
/*#__PURE__*/
function (_Component) {
  _inherits(OptionList, _Component);

  var _super = _createSuper2(OptionList);

  function OptionList(props) {
    var _this;

    _classCallCheck(this, OptionList);

    cov_fz7g5lf8l.f[0]++;
    cov_fz7g5lf8l.s[1]++;
    _this = _super.call(this, props);
    _this.optionInner = void 0;
    _this.lastScrollTop = void 0;
    cov_fz7g5lf8l.s[2]++;
    _this.state = {
      currentIndex: 0,
      hoverIndex: props.hideCreateOption ? (cov_fz7g5lf8l.b[0][0]++, -1) : (cov_fz7g5lf8l.b[0][1]++, 0),
      scrollTop: 0
    };
    cov_fz7g5lf8l.s[3]++;
    _this.hoverMove = _this.hoverMove.bind(_assertThisInitialized(_this));
    cov_fz7g5lf8l.s[4]++;
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_this));
    cov_fz7g5lf8l.s[5]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    cov_fz7g5lf8l.s[6]++;
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    cov_fz7g5lf8l.s[7]++;
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_this));
    cov_fz7g5lf8l.s[8]++;
    _this.lastScrollTop = 0;
    cov_fz7g5lf8l.s[9]++;
    props.bindOptionFunc('handleHover', _this.handleHover);
    cov_fz7g5lf8l.s[10]++;
    props.bindOptionFunc('hoverMove', _this.hoverMove);
    cov_fz7g5lf8l.s[11]++;
    props.bindOptionFunc('getIndex', function () {
      cov_fz7g5lf8l.f[1]++;
      cov_fz7g5lf8l.s[12]++;
      return _this.state.hoverIndex;
    });
    return _this;
  }

  _createClass(OptionList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      cov_fz7g5lf8l.f[2]++;

      var _ref = (cov_fz7g5lf8l.s[13]++, this.props),
          data = _ref.data;

      cov_fz7g5lf8l.s[14]++;

      if ((cov_fz7g5lf8l.b[2][0]++, data !== prevProps.data) && (cov_fz7g5lf8l.b[2][1]++, data.length !== prevProps.data.length)) {
        cov_fz7g5lf8l.b[1][0]++;
        cov_fz7g5lf8l.s[15]++;
        this.lastScrollTop = 0; // eslint-disable-next-line

        cov_fz7g5lf8l.s[16]++;
        this.setState({
          currentIndex: 0,
          scrollTop: 0
        }, function () {
          cov_fz7g5lf8l.f[3]++;
          cov_fz7g5lf8l.s[17]++;

          if (_this2.optionInner) {
            cov_fz7g5lf8l.b[3][0]++;
            cov_fz7g5lf8l.s[18]++;
            setTranslate(_this2.optionInner, '0px', '0px');
            cov_fz7g5lf8l.s[19]++;
            _this2.optionInner.style.marginTop = '0px';
          } else {
            cov_fz7g5lf8l.b[3][1]++;
          }
        });
      } else {
        cov_fz7g5lf8l.b[1][1]++;
      }
    }
  }, {
    key: "getText",
    value: function getText(key) {
      cov_fz7g5lf8l.f[4]++;
      cov_fz7g5lf8l.s[20]++;
      return (cov_fz7g5lf8l.b[4][0]++, this.props.text) && (cov_fz7g5lf8l.b[4][1]++, this.props.text[key]) || (cov_fz7g5lf8l.b[4][2]++, getLocale(key));
    }
  }, {
    key: "hoverMove",
    value: function hoverMove(step) {
      cov_fz7g5lf8l.f[5]++;
      var max = (cov_fz7g5lf8l.s[21]++, this.props.data.length);

      var _ref2 = (cov_fz7g5lf8l.s[22]++, this.props),
          lineHeight = _ref2.lineHeight,
          height = _ref2.height,
          groupKey = _ref2.groupKey;

      var _ref3 = (cov_fz7g5lf8l.s[23]++, this.state),
          hoverIndex = _ref3.hoverIndex,
          currentIndex = _ref3.currentIndex;

      cov_fz7g5lf8l.s[24]++;

      if (hoverIndex === undefined) {
        cov_fz7g5lf8l.b[5][0]++;
        cov_fz7g5lf8l.s[25]++;
        hoverIndex = currentIndex;
      } else {
        cov_fz7g5lf8l.b[5][1]++;
        cov_fz7g5lf8l.s[26]++;
        hoverIndex += step;
      }

      cov_fz7g5lf8l.s[27]++;

      if (hoverIndex >= max) {
        cov_fz7g5lf8l.b[6][0]++;
        cov_fz7g5lf8l.s[28]++;
        hoverIndex = 0;
        cov_fz7g5lf8l.s[29]++;
        this.lastScrollTop = 0;
      } else {
        cov_fz7g5lf8l.b[6][1]++;
      } // jump the group, the group would't be the last, so do't need to fixed the last


      var data = (cov_fz7g5lf8l.s[30]++, this.props.data[hoverIndex]);
      cov_fz7g5lf8l.s[31]++;

      if ((cov_fz7g5lf8l.b[8][0]++, data) && (cov_fz7g5lf8l.b[8][1]++, data[groupKey])) {
        cov_fz7g5lf8l.b[7][0]++;
        cov_fz7g5lf8l.s[32]++;

        if (step > 0) {
          cov_fz7g5lf8l.b[9][0]++;
          cov_fz7g5lf8l.s[33]++;
          hoverIndex += 1;
        } else {
          cov_fz7g5lf8l.b[9][1]++;
          cov_fz7g5lf8l.s[34]++;
          hoverIndex -= 1;
        }
      } else {
        cov_fz7g5lf8l.b[7][1]++;
      }

      cov_fz7g5lf8l.s[35]++;

      if (hoverIndex < 0) {
        cov_fz7g5lf8l.b[10][0]++;
        cov_fz7g5lf8l.s[36]++;
        hoverIndex = max - 1;
      } else {
        cov_fz7g5lf8l.b[10][1]++;
      }

      var scrollTop = (cov_fz7g5lf8l.s[37]++, hoverIndex / max);
      var offset = (cov_fz7g5lf8l.s[38]++, scrollTop * height);
      var emptyHeight = (cov_fz7g5lf8l.s[39]++, hoverIndex * lineHeight + offset);
      cov_fz7g5lf8l.s[40]++;

      if (emptyHeight < this.lastScrollTop + offset) {
        cov_fz7g5lf8l.b[11][0]++;
        cov_fz7g5lf8l.s[41]++;
        // absolute at top
        this.optionInner.style.marginTop = "".concat(offset, "px");
        cov_fz7g5lf8l.s[42]++;
        setTranslate(this.optionInner, '0px', "-".concat(emptyHeight, "px"));
        cov_fz7g5lf8l.s[43]++;
        this.lastScrollTop = emptyHeight - offset;
        cov_fz7g5lf8l.s[44]++;
        currentIndex = hoverIndex - 1;
        cov_fz7g5lf8l.s[45]++;

        if (currentIndex < 0) {
          cov_fz7g5lf8l.b[12][0]++;
          cov_fz7g5lf8l.s[46]++;
          currentIndex = max;
        } else {
          cov_fz7g5lf8l.b[12][1]++;
        }

        cov_fz7g5lf8l.s[47]++;
        this.setState({
          currentIndex: currentIndex,
          scrollTop: emptyHeight / (lineHeight * max)
        });
      } else {
        cov_fz7g5lf8l.b[11][1]++;
        cov_fz7g5lf8l.s[48]++;

        if (emptyHeight + lineHeight > this.lastScrollTop + offset + height) {
          cov_fz7g5lf8l.b[13][0]++;
          cov_fz7g5lf8l.s[49]++;
          // absolute at bottom
          this.optionInner.style.marginTop = "".concat(offset, "px");
          var scrollHeight = (cov_fz7g5lf8l.s[50]++, emptyHeight + lineHeight - height);
          cov_fz7g5lf8l.s[51]++;
          setTranslate(this.optionInner, '0px', "-".concat(scrollHeight, "px"));
          cov_fz7g5lf8l.s[52]++;
          this.lastScrollTop = scrollHeight - offset;
          cov_fz7g5lf8l.s[53]++;
          currentIndex = hoverIndex - Math.ceil(height / lineHeight);
          cov_fz7g5lf8l.s[54]++;

          if (currentIndex < 0) {
            cov_fz7g5lf8l.b[14][0]++;
            cov_fz7g5lf8l.s[55]++;
            currentIndex = 0;
          } else {
            cov_fz7g5lf8l.b[14][1]++;
          }

          cov_fz7g5lf8l.s[56]++;
          this.setState({
            currentIndex: currentIndex,
            scrollTop: scrollHeight / (lineHeight * max)
          });
        } else {
          cov_fz7g5lf8l.b[13][1]++;
          cov_fz7g5lf8l.s[57]++;

          if ((cov_fz7g5lf8l.b[16][0]++, hoverIndex === 0) && (cov_fz7g5lf8l.b[16][1]++, emptyHeight === 0)) {
            cov_fz7g5lf8l.b[15][0]++;
            cov_fz7g5lf8l.s[58]++;
            // reset to top
            this.optionInner.style.marginTop = '0px';
            cov_fz7g5lf8l.s[59]++;
            setTranslate(this.optionInner, '0px', '0px');
            cov_fz7g5lf8l.s[60]++;
            this.setState({
              currentIndex: 0,
              scrollTop: 0
            });
          } else {
            cov_fz7g5lf8l.b[15][1]++;
          }
        }
      }

      cov_fz7g5lf8l.s[61]++;
      this.setState({
        hoverIndex: hoverIndex
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(_x, y, _max, _bar, _v, h, _pixelX, pixelY) {
      cov_fz7g5lf8l.f[6]++;
      cov_fz7g5lf8l.s[62]++;

      if (!this.optionInner) {
        cov_fz7g5lf8l.b[17][0]++;
        cov_fz7g5lf8l.s[63]++;
        return;
      } else {
        cov_fz7g5lf8l.b[17][1]++;
      }

      var _ref4 = (cov_fz7g5lf8l.s[64]++, this.props),
          data = _ref4.data,
          itemsInView = _ref4.itemsInView,
          lineHeight = _ref4.lineHeight,
          autoAdapt = _ref4.autoAdapt,
          resetPosition = _ref4.resetPosition;

      var fullHeight = (cov_fz7g5lf8l.s[65]++, itemsInView * lineHeight);
      var contentHeight = (cov_fz7g5lf8l.s[66]++, data.length * lineHeight - h);
      var scrollTop = (cov_fz7g5lf8l.s[67]++, h > fullHeight ? (cov_fz7g5lf8l.b[18][0]++, 0) : (cov_fz7g5lf8l.b[18][1]++, y));
      cov_fz7g5lf8l.s[68]++;
      this.optionInner.style.marginTop = "".concat(scrollTop * h, "px");
      cov_fz7g5lf8l.s[69]++;

      if ((cov_fz7g5lf8l.b[20][0]++, pixelY === undefined) || (cov_fz7g5lf8l.b[20][1]++, pixelY === 0)) {
        cov_fz7g5lf8l.b[19][0]++;
        cov_fz7g5lf8l.s[70]++;
        this.lastScrollTop = scrollTop * contentHeight;
      } else {
        cov_fz7g5lf8l.b[19][1]++;
        cov_fz7g5lf8l.s[71]++;
        this.lastScrollTop += pixelY;
        cov_fz7g5lf8l.s[72]++;

        if (this.lastScrollTop < 0) {
          cov_fz7g5lf8l.b[21][0]++;
          cov_fz7g5lf8l.s[73]++;
          this.lastScrollTop = 0;
        } else {
          cov_fz7g5lf8l.b[21][1]++;
        } // scroll over bottom


        cov_fz7g5lf8l.s[74]++;

        if (this.lastScrollTop > contentHeight) {
          cov_fz7g5lf8l.b[22][0]++;
          cov_fz7g5lf8l.s[75]++;
          this.lastScrollTop = contentHeight;
        } else {
          cov_fz7g5lf8l.b[22][1]++;
        }

        cov_fz7g5lf8l.s[76]++;
        scrollTop = this.lastScrollTop / contentHeight;
        cov_fz7g5lf8l.s[77]++;
        this.optionInner.style.marginTop = "".concat(scrollTop * h, "px");
      }

      var index = (cov_fz7g5lf8l.s[78]++, Math.floor(this.lastScrollTop / lineHeight) - 1);
      cov_fz7g5lf8l.s[79]++;

      if (data.length - itemsInView < index) {
        cov_fz7g5lf8l.b[23][0]++;
        cov_fz7g5lf8l.s[80]++;
        index = data.length - itemsInView;
      } else {
        cov_fz7g5lf8l.b[23][1]++;
      }

      cov_fz7g5lf8l.s[81]++;

      if (index < 0) {
        cov_fz7g5lf8l.b[24][0]++;
        cov_fz7g5lf8l.s[82]++;
        index = 0;
      } else {
        cov_fz7g5lf8l.b[24][1]++;
      }

      cov_fz7g5lf8l.s[83]++;
      setTranslate(this.optionInner, '0px', "-".concat(this.lastScrollTop + scrollTop * h, "px"));
      cov_fz7g5lf8l.s[84]++;
      this.setState({
        scrollTop: scrollTop,
        currentIndex: index
      });
      cov_fz7g5lf8l.s[85]++;

      if ((cov_fz7g5lf8l.b[26][0]++, autoAdapt) && (cov_fz7g5lf8l.b[26][1]++, resetPosition)) {
        cov_fz7g5lf8l.b[25][0]++;
        cov_fz7g5lf8l.s[86]++;
        resetPosition(true);
      } else {
        cov_fz7g5lf8l.b[25][1]++;
      }
    }
  }, {
    key: "handleHover",
    value: function handleHover(index, force) {
      cov_fz7g5lf8l.f[7]++;
      cov_fz7g5lf8l.s[87]++;

      if (((cov_fz7g5lf8l.b[28][0]++, this.props.control === 'mouse') || (cov_fz7g5lf8l.b[28][1]++, force)) && (cov_fz7g5lf8l.b[28][2]++, this.state.hoverIndex !== index)) {
        cov_fz7g5lf8l.b[27][0]++;
        cov_fz7g5lf8l.s[88]++;
        this.setState({
          hoverIndex: index
        });
      } else {
        cov_fz7g5lf8l.b[27][1]++;
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      cov_fz7g5lf8l.f[8]++;
      cov_fz7g5lf8l.s[89]++;
      this.props.onControlChange('mouse');
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this3 = this;

      cov_fz7g5lf8l.f[9]++;

      var _ref5 = (cov_fz7g5lf8l.s[90]++, this.props),
          loading = _ref5.loading,
          data = _ref5.data,
          renderPending = _ref5.renderPending,
          height = _ref5.height,
          lineHeight = _ref5.lineHeight,
          itemsInView = _ref5.itemsInView,
          datum = _ref5.datum,
          keygen = _ref5.keygen,
          multiple = _ref5.multiple,
          onChange = _ref5.onChange,
          renderItem = _ref5.renderItem,
          groupKey = _ref5.groupKey,
          filterText = _ref5.filterText,
          emptyText = _ref5.emptyText;

      var _ref6 = (cov_fz7g5lf8l.s[91]++, this.state),
          hoverIndex = _ref6.hoverIndex,
          currentIndex = _ref6.currentIndex;

      var scroll = (cov_fz7g5lf8l.s[92]++, '');
      var scrollHeight = (cov_fz7g5lf8l.s[93]++, lineHeight * data.length);
      cov_fz7g5lf8l.s[94]++;

      if (height < scrollHeight) {
        cov_fz7g5lf8l.b[29][0]++;
        cov_fz7g5lf8l.s[95]++;
        scroll = 'y';
      } else {
        cov_fz7g5lf8l.b[29][1]++;
      }

      cov_fz7g5lf8l.s[96]++;

      if (loading) {
        cov_fz7g5lf8l.b[30][0]++;
        cov_fz7g5lf8l.s[97]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: selectClass(getDirectionClass('option')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 201,
              columnNumber: 9
            }
          }, typeof loading === 'boolean' ? (cov_fz7g5lf8l.b[31][0]++,
          /*#__PURE__*/
          React.createElement(Spin, {
            size: 20,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 202,
              columnNumber: 43
            }
          })) : (cov_fz7g5lf8l.b[31][1]++, loading))
        );
      } else {
        cov_fz7g5lf8l.b[30][1]++;
      }

      cov_fz7g5lf8l.s[98]++;

      if ((cov_fz7g5lf8l.b[33][0]++, data.length === 0) || (cov_fz7g5lf8l.b[33][1]++, renderPending)) {
        cov_fz7g5lf8l.b[32][0]++;
        cov_fz7g5lf8l.s[99]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: selectClass(getDirectionClass('option')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 206,
              columnNumber: 14
            }
          }, (cov_fz7g5lf8l.b[34][0]++, emptyText) || (cov_fz7g5lf8l.b[34][1]++, this.getText('noData')))
        );
      } else {
        cov_fz7g5lf8l.b[32][1]++;
      }

      cov_fz7g5lf8l.s[100]++;
      return (
        /*#__PURE__*/
        React.createElement(Scroll, {
          scroll: scroll,
          style: {
            height: scroll ? (cov_fz7g5lf8l.b[35][0]++, height) : (cov_fz7g5lf8l.b[35][1]++, undefined)
          },
          onScroll: this.handleScroll,
          scrollHeight: data.length * lineHeight,
          scrollTop: this.state.scrollTop,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 208,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: function ref(el) {
            cov_fz7g5lf8l.f[10]++;
            cov_fz7g5lf8l.s[101]++;
            _this3.optionInner = el;
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 215,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            height: currentIndex * lineHeight
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 220,
            columnNumber: 11
          }
        }), data.slice(currentIndex, currentIndex + itemsInView).map(function (d, i) {
          cov_fz7g5lf8l.f[11]++;
          cov_fz7g5lf8l.s[102]++;
          return (
            /*#__PURE__*/
            React.createElement(Option, {
              isActive: datum.check(d),
              disabled: datum.disabled(d),
              isHover: hoverIndex === currentIndex + i,
              key: (cov_fz7g5lf8l.b[37][0]++, d) && (cov_fz7g5lf8l.b[37][1]++, d[groupKey]) ? (cov_fz7g5lf8l.b[36][0]++, "__".concat(d[groupKey], "__")) : (cov_fz7g5lf8l.b[36][1]++, getKey(d, keygen, i)),
              index: currentIndex + i,
              data: d,
              multiple: multiple,
              onClick: onChange,
              renderItem: renderItem,
              onHover: _this3.handleHover,
              groupKey: groupKey,
              filterText: filterText,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 222,
                columnNumber: 13
              }
            })
          );
        })))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_fz7g5lf8l.f[12]++;

      var _ref7 = (cov_fz7g5lf8l.s[103]++, this.props),
          control = _ref7.control,
          focus = _ref7.focus,
          style = _ref7.style,
          selectId = _ref7.selectId,
          autoClass = _ref7.autoClass,
          getRef = _ref7.getRef,
          customHeader = _ref7.customHeader,
          renderOptionList = _ref7.renderOptionList,
          loading = _ref7.loading;

      var result = (cov_fz7g5lf8l.s[104]++,
      /*#__PURE__*/
      React.createElement(React.Fragment, null, customHeader, this.renderList()));
      cov_fz7g5lf8l.s[105]++;
      return (
        /*#__PURE__*/
        React.createElement(ScaleList, {
          show: focus,
          onMouseMove: this.handleMouseMove,
          style: style,
          "data-id": selectId,
          className: classnames(selectClass('options', "control-".concat(control)), autoClass),
          getRef: getRef,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 251,
            columnNumber: 7
          }
        }, getCustomList(result, renderOptionList, loading))
      );
    }
  }]);

  return OptionList;
}(Component);

export default OptionList;